import { render, staticRenderFns } from "./TiposDePesquisa.vue?vue&type=template&id=5cd1ef93&"
import script from "./TiposDePesquisa.vue?vue&type=script&lang=js&"
export * from "./TiposDePesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports